export const paymentDashboardConstants = {
    GET_PAYMENT_DASHBOARD_PENDING:   'GET_PAYMENT_DASHBOARD_PENDING',
    GET_PAYMENT_DASHBOARD_FULFILLED:   'GET_PAYMENT_DASHBOARD_FULFILLED',
    GET_PAYMENT_DASHBOARD_REJECTED:   'GET_PAYMENT_DASHBOARD_REJECTED',
};
